import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { useTranslation } from "react-i18next";
import { uri } from "../../../../../help/Api";
import toast from "react-hot-toast";
import axios from "axios";
import { reFormatDate } from "../../../../../utils/utils";
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));

export default function SarfTwreedSearchTable(props) {
    const { data, setPrevent,handCloseDw,getSearchHeadData} = props;


    const stylH = {
        // borderWidth: 1,
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000"
    }
    const onRowClick = async (rowData) => {
        setPrevent(false);
        await axios.get(uri + `TwreedSrf/TwreedSarfSubs?twreedSarf_id=${rowData.id}`).then(res => {
            
            handCloseDw();
            getSearchHeadData({...rowData},res.data);
          
        }).catch(err => {
          console.log(err);
          toast.error("لم يتم جلب البيانات")
        });
        // setSubmitting(false)
      };
    


    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    return (
        <TableContainer component={Paper} >
            <Table
                size="small" aria-label="a dense table" >
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: "#3f51b5",
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 15,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={stylH} align="center">
                            {"رقم الامر"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"التاريخ"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"الوقت"}
                        </TableCell>
                      
                        <TableCell style={stylH} align="center">
                            {"المخزن"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"البيان"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"مركز التكلفة"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"اجمالي الكميات"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"اجمالي المبلغ"}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row,i) => (
                        <TableRow key={i}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 600,
                                fontFamily: "Amiri-Regular",
                                fontSize: 15,
                                border: "solid 0.6px"
                            }}
                           >
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.no}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }} >{reFormatDate(row.date)}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.time}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.safeName}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.notes}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.centerName}</TableCell>  
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{parseFloat(row?.tot_val??0).toFixed(2)}</TableCell>                           
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{parseFloat(row?.tot_amount??0).toFixed(2)}</TableCell>                           
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
